import React, { useState } from 'react'
import Button from '@3mcom/mds-library/dist/node/Button'
import RichContent from '../../components/RichContent'
import CtaTypeEnum from '../../../common/constants/CtaTypeEnum'
import {
    primaryButtonStyle,
    primaryButtonStyleHover,
    secondaryButtonStyle,
    secondaryButtonStyleHover,
    tertiaryButtonStyle,
    tertiaryButtonStyleHover
} from '../../constants/MDSButtonStyle'

const LightboxCTA = ({ cta, buttonClass = '', ...rest }) => {
    const [isHovered, setIsHovered] = useState(false)

    /**
     * Returns the correct button styles based on buttonClass and hover state.
     * Styles are applied inline because a 3m_theme_assets script removes them.
     * @returns {Object} Inline style object for the button
     */
    const getButtonStyle = () => {
        if (buttonClass.includes('primary')) {
            return isHovered ? primaryButtonStyleHover : primaryButtonStyle
        }
        if (buttonClass.includes('secondary')) {
            return isHovered ? secondaryButtonStyleHover : secondaryButtonStyle
        }
        if (buttonClass.includes('tertiary')) {
            return isHovered ? tertiaryButtonStyleHover : tertiaryButtonStyle
        }
        return {}
    }

    /**
     * Returns the lightbox element ID mapped to the given snaps2Id.
     * The lightbox script uses these IDs to trigger the form.
     * @param {string} snaps2Id - The snaps2Id of the CTA
     * @returns {string} The element ID used by the lightbox script
     */
    const getLightboxId = (snaps2Id) => {
        switch (snaps2Id) {
            case CtaTypeEnum.CONTACT_ACQUISITION:
                return 'contactLightboxButton'
            case CtaTypeEnum.LEAD_FORM_1:
                return 'leadLightboxButton'
            case CtaTypeEnum.LEAD_FORM_2:
                return 'lead2LightboxButton'
        }
    }

    const isLightboxCTA = cta?.hasLightbox && cta?.html

    return (
        <>
            {isLightboxCTA ? (
                <>
                    <RichContent richContentObj={{ html: cta.html, oid: cta.oid }} />
                    <button
                        id={getLightboxId(cta.snaps2Id)}
                        style={getButtonStyle()}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        data-testid={`cta-${cta.snaps2Id}`}
                    >
                        {cta.label}
                    </button>
                </>
            ) : (
                <Button className={buttonClass} {...rest}>
                    <span>{cta.label}</span>
                </Button>
            )}
        </>
    )
}

export default LightboxCTA
